import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import circumventLogoSecurity from '../assets/circumvent-logo-security.png';
import './Navbar.css';

const SOLUTIONS_MENU_ID = 'navbar-solutions-menu';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 8);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLogoClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  const handleNavClick = (targetId) => {
    setMenuOpen(false);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (targetId === 'contact') {
      ReactGA.event({
        category: 'user_engagement',
        action: 'early_access_click',
        label: 'navbar_button',
      });
    }
  };

  const handleLoginClick = () => {
    setMenuOpen(false);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    ReactGA.event({
      category: 'user_engagement',
      action: 'login_click',
      label: 'navbar_button',
    });
  };

  return (
    <nav className={`navbar ${isScrolled ? 'is-scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="logo" aria-label="Circumvent home" onClick={handleLogoClick}>
          <img
            src={circumventLogoSecurity}
            alt="Circumvent"
            className="logo-img"
          />
        </Link>

        <div className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <button
            className="close-button"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <i className="fas fa-times"></i>
          </button>
          <li className="nav-item nav-item--dropdown">
            <div className="nav-dropdown">
              <Link
                to="/solutions"
                className="nav-dropdown__trigger"
                aria-controls={SOLUTIONS_MENU_ID}
                onClick={() => handleNavClick('solutions')}
              >
                Solutions
                <span className="nav-dropdown__chevron" aria-hidden="true"></span>
              </Link>
              <div
                id={SOLUTIONS_MENU_ID}
                className="nav-dropdown__list nav-dropdown__list--split"
                role="region"
                aria-label="Solutions"
              >
                <div className="nav-dropdown__column">
                  <p className="nav-dropdown__column-heading" id="navbar-solutions-heading-left">
                    Explore solutions
                  </p>
                  <ul className="nav-dropdown__link-list" aria-labelledby="navbar-solutions-heading-left">
                    <li>
                      <Link
                        to="/solutions"
                        className="nav-dropdown__link"
                        onClick={() => handleNavClick('solutions')}
                      >
                        Solutions overview
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/solutions/context"
                        className="nav-dropdown__link"
                        onClick={() => handleNavClick('solutions')}
                      >
                        Business Context
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/solutions/automated-triage"
                        className="nav-dropdown__link"
                        onClick={() => handleNavClick('solutions')}
                      >
                        Automated Triage
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/solutions/assisted-remediation"
                        className="nav-dropdown__link"
                        onClick={() => handleNavClick('solutions')}
                      >
                        Assisted Remediation
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="nav-dropdown__column">
                  <p className="nav-dropdown__column-heading" id="navbar-solutions-heading-right">
                    Agents
                  </p>
                  <Link
                    to="/solutions/agents"
                    className="nav-dropdown__featured"
                    onClick={() => handleNavClick('solutions')}
                  >
                    <span className="nav-dropdown__featured-title">
                      Circumvent Investigation and Remediation Agents
                    </span>
                    <span className="nav-dropdown__featured-desc">
                      Agents investigate findings, run triage, and route verified risk into the tools your teams
                      already use.
                    </span>
                    <span className="nav-dropdown__featured-cta">
                      Learn how it works
                      <span className="nav-dropdown__featured-cta-arrow" aria-hidden="true">
                        →
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </li>
          <li className="nav-item">
            <Link to="/#integrations" onClick={() => handleNavClick('integrations')}>Integrations</Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" onClick={() => handleNavClick('blog')}>Blog</Link>
          </li>
          <li className="nav-item">
            <Link to="/#about" onClick={() => handleNavClick('about')}>About</Link>
          </li>
          <li className="nav-item">
            <Link to="/#contact" onClick={() => handleNavClick('contact')}>Contact</Link>
          </li>
          <li className="nav-item login">
            <a
              href="https://console.circumvent.io/horizon/login"
              className="btn btn-outline"
              onClick={handleLoginClick}
            >
              Login
            </a>
          </li>
          <li className="nav-item signin">
            <Link to="/#contact" onClick={() => handleNavClick('contact')} className="btn btn-gradient">
              Request Access
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
